const propertyAccommodationsPathMap: Record<string, string> = {
	northsandiego: 'villarentals',
};

export const mapAccommodationsPagePath = (path?: string, propertyId?: string) => {
	if (!path || (!propertyId && path.split('/').length < 7)) {
		return path;
	}

	const property = propertyId || path.split('/')[6];
	if (path.includes('/accommodations') && propertyAccommodationsPathMap[property]) {
		path = path.replace('/accommodations', `/${propertyAccommodationsPathMap[property]}`);
	}
	return path;
};

export const getAccommodationsSlug = (propertyId: string) =>
	propertyAccommodationsPathMap[propertyId] || 'accommodations';
